import sortBy from 'lodash/sortBy';

interface IValidatedUrlFilter {
  updatedQuery: string,
  hasChanged: boolean,
}

export const validateUrlFilter = (
  query: string = '',
  collection: { abbreviation: string }[],
  defaultValue: string,
): IValidatedUrlFilter => {
  let result = {
    updatedQuery: '',
    hasChanged: false,
  };

  if (!query) {
    result.updatedQuery = defaultValue;
    result.hasChanged = true;
    return result;
  }

  const abbreviations = sortBy(collection.map((item) => item.abbreviation));

  const queryArray = query.split(',');

  const baseLength = queryArray.length;

  const queryArrayFiltered = queryArray.filter((item) => abbreviations.includes(item));

  if (queryArrayFiltered.length > 0 && queryArrayFiltered.length !== baseLength) {
    result.updatedQuery = queryArrayFiltered.join(',');
    result.hasChanged = true;
  } else if (queryArrayFiltered.length === 0) {
    result.updatedQuery = defaultValue;
    result.hasChanged = true;
  } else {
    result.updatedQuery = queryArrayFiltered.join(',');
  }

  return result;
};
